import constants from "../../core/constants";
import map from "lodash/fp/map";
import capitalize from "lodash/fp/capitalize";
import moment from "moment";

class TagsPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Tag",
      state: "tag",
      name: "tag",
    };

    this.fields = [
      { name: "name", title: "Name" },
      { name: "createdAt", title: "created At" },
      { name: "city", title: "City" },
      { name: "description", title: "Description" },
    ];

    this.addOptions = {
      title: "Add New Tag",
      icon: "add",
      fields: [
        {
          name: "city",
          title: "City",
          resource: "City",
          isResource: true,
          isRequired: false,
        },
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "description",
          title: "Description",
          type: "text",
          isText: true,
          isRequired: false,
        },
      ],
    };
  }

  justify(data) {
    const format = (item) => {
      item.name = capitalize(item._source.name);
      item.createdAt = moment(item.createdAt).format(constants.dateFormat);
      item.city = item._source.city.name;
      item.description = item._source.description;

      return item;
    };

    return map(format)(data);
  }
}

export default TagsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/tags/tags.transforms.js